import { useState, useRef } from 'react';
import { Button } from '@/components/ui/button';
import { Download, Plus } from 'lucide-react';
import ReservationsSubNav from './ReservationsSubNav';
import ReservationsBookingsView, { ReservationsBookingsViewRef } from './ReservationsBookingsView';
import ReservationsGuestsView, { ReservationsGuestsViewRef } from './ReservationsGuestsView';
import useRolePermissions from '@/hooks/admin/shared/useRolePermissions';

type SubTab = 'bookings' | 'guests';

const ReservationsTab = () => {
  const [activeSubTab, setActiveSubTab] = useState<SubTab>('bookings');
  
  const bookingsViewRef = useRef<ReservationsBookingsViewRef>(null);
  const guestsViewRef = useRef<ReservationsGuestsViewRef>(null);
  const { canCreate } = useRolePermissions();

  const handleDownloadCSV = () => {
    if (activeSubTab === 'bookings') {
      bookingsViewRef.current?.downloadCSV();
    }
  };

  const handleCreate = () => {
    if (activeSubTab === 'bookings') {
      bookingsViewRef.current?.createNew();
    } else {
      guestsViewRef.current?.createNew();
    }
  };

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <div className="flex items-center justify-between min-h-10">
          <h2 className="text-2xl font-bold">Reservaciones</h2>
          
          <div className="flex items-center gap-2">
            {activeSubTab === 'bookings' && (
              <Button
                onClick={handleDownloadCSV}
                variant="outline"
                className="flex items-center gap-2"
              >
                <Download size={16} />
                Descargar CSV
              </Button>
            )}

            {canCreate && (
              <Button
                onClick={handleCreate}
                className="bg-brand-primary hover:bg-brand-primary-hover flex items-center gap-2"
              >
                <Plus size={16} />
                {activeSubTab === 'bookings' ? 'Nueva Reservación' : 'Agregar Huésped'}
              </Button>
            )}
          </div>
        </div>
        
        <ReservationsSubNav 
          activeSubTab={activeSubTab} 
          onSubTabChange={setActiveSubTab} 
        />
      </div>

      {activeSubTab === 'bookings' ? (
        <ReservationsBookingsView ref={bookingsViewRef} />
      ) : (
        <ReservationsGuestsView ref={guestsViewRef} />
      )}
    </div>
  );
};

export default ReservationsTab;
